import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Hero from './components/Hero';
import Qualifications from './components/Qualifications';
import ProjectFiles from './components/ProjectFiles';
import FileDownload from './components/FileDownload';
import TechAchievements from './components/TechAchievements';
import Ecosystem from './components/Ecosystem';
import LiveBoard from './components/LiveBoard';
import Cta from './components/Cta';

export default function Evidence() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="相关资料 | 资质 · 文件 · 技术 · 生态 · 数据"
        description="华辉数智技术与九畴云市的资质、项目文件、技术成果、合作生态与实时数据集中呈现，证据可核、成果可查。"
        keywords="相关资料,公司资质,项目文件,技术成果,合作生态"
        path="/about/resources"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: '相关资料',
          description: '华辉数智技术与九畴云市的资质、项目文件、技术成果、合作生态与实时数据',
        }}
      />
      <main>
        <Hero />
        <Breadcrumb items={[{ label: '关于我们' }, { label: '相关资料' }]} />
        <Qualifications />
        <ProjectFiles />
        <FileDownload />
        <TechAchievements />
        <Ecosystem />
        <LiveBoard />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}